import { render, staticRenderFns } from "./ChartPie.vue?vue&type=template&id=6c6a9b4e&scoped=true&"
import script from "./ChartPie.vue?vue&type=script&lang=js&"
export * from "./ChartPie.vue?vue&type=script&lang=js&"
import style0 from "./ChartPie.vue?vue&type=style&index=0&id=6c6a9b4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6a9b4e",
  null
  
)

export default component.exports